<template>
  <b-card>
    <div
      class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
    >
      <h6>جزوه</h6>
    </div>
    <p class="m-2 " v-html="pamphlet"></p>
    <hr class="my-1" v-if="pamphlet_file && pamphlet" />
    <p class="m-2 cursor-pointer" v-if="pamphlet_file">
      <b-img
        :src="require('@/assets/images/icons/doc.png')"
        height="auto"
        width="20"
        class="mr-1"
      />
      <b-link :href="pamphlet_file">لینک دانلود</b-link>
    </p>
  </b-card>
</template>

<script>
import { BCard, BImg, BLink } from "bootstrap-vue";
export default {
  components: {
    BCard,
    BImg,
    BLink,
  },
  props: ["pamphlet", "pamphlet_file"],
};
</script>
